/**
 * Created by chuongnv 2017/10/25.
 */
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()

export class EvsStoreService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
        this.setEndPoint('/g_store');
    }

    // get all
    getAll(data?: any) {
        return this.get('/g_store', data);
    }
    public downloadExcel(request: any) {
        return this.getExcel('/g_store/excel', request);
    }

    getDetaiById(id) {
        return this.get("/g_store/" + id);
    }

    createNew(data: any) {
        return this.post("/qr_aps/g_store", data);
    }

    updateById(id, data: any) {
        return this.put("/qr_aps/g_store/" + id, data);
    }

    deleteById(id) {
        return this.delete("/qr_aps/g_store/" + id);
    }

    multiDelete(ids: any) {
        return this.multiPost("/g_store/delete", ids);
    }
}



// WEBPACK FOOTER //
// /app/src/app/common/services/EvsStore.service.ts